declare var THREE: any;
import {Hole} from './Hole';

export class Edge implements Feeney.IEdge {

  private _start;
  private _end;
  public readonly id: string;
  public readonly holes: Array<Hole>;
  public hidden: boolean;

  constructor(
    start,
    end,
    holes = [],
    hidden = false
  ) {
    this._start = new THREE.Vector3(start.x, 0, start.z);
    this._end = new THREE.Vector3(end.x, 0, end.z);
    this.id = THREE.Math.generateUUID();
    this.holes = holes;
    this.hidden = hidden;
  }

  get start() {
    return this._start.clone();
  }

  get end() {
    return this._end.clone();
  }

  get direction() {
    return this.end
      .sub(this.start)
      .normalize();
  }

  get center() {
    const offset = this.direction
      .multiplyScalar(this.length / 2);
    return this.start
      .add(offset);
  }

  get normal() {
    return this.end
      .sub(this.start)
      .applyAxisAngle(new THREE.Vector3(0, 1, 0), THREE.Math.degToRad(-90))
      .normalize();
  }

  get length(): number {
    return this.start.distanceTo(this.end);
  }

  get rotationAngle(): number {
    return -Math.atan2(this.end.z - this.start.z, this.end.x - this.start.x);
  }

  addHole = (start, end) => this.holes.push(new Hole(start, end));

}



// WEBPACK FOOTER //
// ./src/app/services/railing/Edge.ts